module.exports = "/_next/static/images/MiamiLogo-c2ecbf5d56d1af8bcdd16d0d2a137256.png";